import { useState, useCallback } from 'react'
import { toastError, toastSuccess, toastLoading, toastDismiss } from '../utils/toastHelper'

import { ApiClient } from '../services/api'

interface QRLocatorData {
  valid: boolean
  message: string
  reserva_id?: string
  cliente_nombre?: string
  espacio_nombre?: string
  espacio_id?: string
  ubicacion?: {
    lat: number
    lng: number
  }
  fecha_entrada?: string
  fecha_salida?: string
  plano_x?: number
  plano_y?: number
  plano_radio?: number
}

interface QRLocatorResponse {
  valid: boolean
  data?: QRLocatorData
}

export const useQRLocator = () => {
  const [isLocating, setIsLocating] = useState(false)
  const [locatorResult, setLocatorResult] = useState<QRLocatorData | null>(null)

  const locateQR = useCallback(async (qrData: string) => {
    setIsLocating(true)
    setLocatorResult(null)

    try {
      // Enviar QR al backend para obtener ubicación
      const response = await ApiClient.post<QRLocatorResponse>(
        '/api/qr/localize',
        { qr_data: qrData }
      )

      // El ApiClient ya desenvuelve automáticamente la respuesta wrapper
      const locatorData = response as QRLocatorData

      setLocatorResult(locatorData)
      return locatorData
    } catch (error) {
      const errorMsg = error instanceof Error ? error.message : 'Error desconocido'
      const result: QRLocatorData = {
        valid: false,
        message: `❌ Error al procesar QR: ${errorMsg}`,
      }
      setLocatorResult(result)
      return result
    } finally {
      setIsLocating(false)
    }
  }, [])

  const clearResult = useCallback(() => {
    setLocatorResult(null)
  }, [])

  return {
    isLocating,
    locatorResult,
    locateQR,
    clearResult,
  }
}
